module.exports = __webpack_public_path__ + "img/cdpz.157c5eb2.png";